export enum EnumTipoDeOrigem {
  Cadastrado = 'cadastrado',
  ImportadoCsv = 'csv',
  ImportadoIfood = 'ifood',
  ImportadoIfoodApi = 'ifoodapi',
  ImportadoAnotaAi = 'anotaai',
  ImportadoKeeta = 'keeta',
  Importado99Food = '99food',
  ImportadoEcletica = 'ecletica',
  ImportadoBluesoft = 'bluesoft',
  ImportadoSaipos = 'saipos',
  ImportadoMenew = 'menew',
  ImportadoRPInfo = 'rpinfo',
  ImportadoChinaInBox = 'chinainbox',
  ImportadoTeknisa= 'teknisa',
  ImportadoGcom = 'gcom',
  ImportadoOpenDelivery= 'opendelivery',
}
